export const rutValidation = (value: string): boolean =>
  /^[\d.]{3,}-?[\dk]?$/i.test(value);
